if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      // Reuse the theme's single CartDrawer/Cart instances: cart:refresh makes them re-render
      // and rebind their replaced controls. Constructing new instances here stacked permanent
      // document listeners on every quick add (and ran three times per add, once per section).
      dispatchCustomEvent('cart:refresh');


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      // Reuse the theme's single CartDrawer/Cart instances: cart:refresh makes them re-render
      // and rebind their replaced controls. Constructing new instances here stacked permanent
      // document listeners on every quick add (and ran three times per add, once per section).
      dispatchCustomEvent('cart:refresh');
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
/* patch40 accessibility (WCAG 2.1 AA): the side panels (cart, search, product) act as dialogs. Tab and Shift+Tab stay inside the
   open panel, Escape closes only the open panel, and focus goes back to what opened it (Add to Cart, the cart or search icon).
   Closed panels are inert (out of the Tab order and hidden from screen readers); the slide animation is untouched. */
var FW_PANEL_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), shop-pay-wallet-button, shopify-google-pay-button';
var fwLastOutsideFocus = null;
function fwVisible(el) {
  return !!(el && el.isConnected && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert],[hidden]'));
}
function fwPanelFocusables(panel) {
  return Array.prototype.filter.call(panel.querySelectorAll(FW_PANEL_FOCUSABLE), fwVisible);
}
function fwForeignFocus() {
  // focus in a third-party overlay outside the page wrapper (wallet, app or chat dialogs): leave its keys alone
  let a = document.activeElement, wrapper = document.getElementById('wrapper');
  return !!(a && a !== document.body && wrapper && !wrapper.contains(a));
}
function fwActivePanel() {
  let open = document.querySelectorAll('.side-panel.active');
  return open.length ? (document.querySelector('.side-panel.product-drawer.active') || open[open.length - 1]) : null;
}
function fwFocusFirstOf(list) {
  for (let i = 0; i < list.length; i++) {
    list[i].focus();
    let a = document.activeElement;
    if (a === list[i] || list[i].contains(a)) return true;
  }
  return false;
}
function fwPanelReturnFocus(panel) {
  let target = panel.fwReturnTo;
  panel.fwReturnTo = null;
  if (target && fwVisible(target) && !target.closest('.side-panel:not(.active)')) {
    target.focus();
    if (document.activeElement === target) return;
  }
  let fallback = panel.classList.contains('cart-drawer') ? document.getElementById('cart-drawer-toggle') :
    panel.classList.contains('search-drawer') ? document.querySelector('.thb-quick-search') : null;
  fallback?.focus();
}
function fwClosePanel(panel) {
  if (!panel) return;
  panel.classList.remove('active');
  if (document.body.classList.contains('open-cc--product')) {
    document.body.classList.remove('open-cc--product');
    setTimeout(() => {
      let content = document.querySelector('#Product-Drawer-Content');
      if (content) content.innerHTML = '';
    }, 260);
  } else {
    document.body.classList.remove('open-cc');
  }
  fwPanelReturnFocus(panel);
}
function fwCartLinkLabel() {
  let link = document.getElementById('cart-drawer-toggle');
  if (!link) return;
  let count = link.querySelector('.thb-item-count');
  let n = parseInt(((count && count.textContent) || '').trim(), 10);
  link.setAttribute('aria-label', isNaN(n) ? 'Cart, more than 99 items' : 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
}
(function () {
  // Remember what opened each panel: an explicit opener (cart or search icon, the pack page Add to Cart), else the focused control
  // outside the panel, else the last control focused outside any panel (the add button may already be disabled or blurred).
  document.querySelectorAll('.side-panel').forEach((panel) => {
    let wasOpen = panel.classList.contains('active');
    if (!wasOpen) panel.setAttribute('inert', '');
    new MutationObserver(() => {
      let open = panel.classList.contains('active');
      panel.toggleAttribute('inert', !open);
      if (open && !wasOpen) {
        let a = document.activeElement;
        panel.fwReturnTo = panel.fwNextOpener || (a && a !== document.body && !panel.contains(a) ? a : fwLastOutsideFocus);
        panel.fwNextOpener = null;
      }
      wasOpen = open;
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  });
  // The cart drawer is opened and focused in one task (cart-drawer:open); lift inert first (this listener is added before CartDrawer's).
  document.addEventListener('cart-drawer:open', () => document.getElementById('Cart-Drawer')?.removeAttribute('inert'));
  document.addEventListener('click', (e) => {
    let t = e.target.closest && e.target.closest('#cart-drawer-toggle, .thb-quick-search');
    if (!t) return;
    let panel = document.getElementById(t.id === 'cart-drawer-toggle' ? 'Cart-Drawer' : 'Search-Drawer');
    if (panel && !panel.classList.contains('active')) panel.fwNextOpener = t;
  }, true);
  document.addEventListener('focusin', (e) => {
    let t = e.target;
    if (t && t.closest && !t.closest('.side-panel')) fwLastOutsideFocus = t;
    // Focus that reaches the page behind an open dialog panel (for example out of the PayPal frame) goes back into the panel.
    let panel = fwActivePanel();
    if (!panel || !panel.hasAttribute('aria-modal') || panel.contains(t)) return;
    let wrapper = document.getElementById('wrapper');
    if (!wrapper || !wrapper.contains(t)) return; // third-party overlays outside the page wrapper are left alone
    if (!fwFocusFirstOf(fwPanelFocusables(panel))) panel.focus();
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || fwForeignFocus()) return;
    let panel = fwActivePanel();
    if (!panel) return;
    let f = fwPanelFocusables(panel);
    if (!f.length) {
      e.preventDefault();
      panel.focus();
      return;
    }
    let a = document.activeElement, first = f[0], last = f[f.length - 1];
    if (!panel.contains(a)) {
      e.preventDefault();
      fwFocusFirstOf(e.shiftKey ? f.slice().reverse() : f);
    } else if (e.shiftKey && (a === first || a === panel)) {
      e.preventDefault();
      fwFocusFirstOf(f.slice().reverse());
    } else if (!e.shiftKey && (a === last || last.contains(a))) {
      e.preventDefault();
      fwFocusFirstOf(f);
    }
  });
  // The header cart link is named by its count only; keep a full name in step with the count the cart re-render writes.
  let cartLink = document.getElementById('cart-drawer-toggle');
  if (cartLink) {
    fwCartLinkLabel();
    new MutationObserver(fwCartLinkLabel).observe(cartLink, { childList: true, subtree: true, characterData: true });
  }
})();

class PanelClose extends HTMLElement {

  constructor() {
    super();

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    // One Escape and overlay listener for the page (each close control used to add its own and close every panel).
    if (window.fwPanelCloseBound) return;
    window.fwPanelCloseBound = true;
    let cc = document.querySelector('.click-capture');
    // Escape belongs to the drawer only if, on keydown, focus was not in a third-party overlay (which may close itself on keydown).
    let escOwned = false;
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !e.repeat) escOwned = !fwForeignFocus();
    }, true);
    document.addEventListener('keyup', (e) => {
      if (e.code && e.code.toUpperCase() === 'ESCAPE' && escOwned) {
        escOwned = false;
        fwClosePanel(fwActivePanel());
      }
    });
    cc?.addEventListener('click', (e) => {
      fwClosePanel(document.querySelector('.side-panel.active'));
    });
  }

  close_panel(e) {
    e.preventDefault();
    fwClosePanel(e.target.closest('.side-panel'));
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let button = document.getElementById('cart-drawer-toggle');


    // Add functionality to buttons
    button?.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      dispatchCustomEvent('cart-drawer:open');
    });

    document.addEventListener('cart-drawer:open', () => {
      (this.container.querySelector('.side-panel-close button') || this.container).focus();
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      // Bind once per element: re-render paths call this repeatedly on the same nodes, and a
      // second handler sent a second removal for the same line index (deleting the next item).
      if (remove.dataset.fwRemoveBound === 'true') return;
      remove.dataset.fwRemoveBound = 'true';
      remove.addEventListener('click', (event) => {
        this.updateQuantity(remove.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    let notes = notes_toggle.nextElementSibling;
    notes_toggle.setAttribute('aria-expanded', notes.classList.contains('active') ? 'true' : 'false');
    notes.inert = !notes.classList.contains('active');
    notes_toggle.addEventListener('click', (event) => {
      notes.inert = false;
      notes.classList.add('active');
      notes_toggle.setAttribute('aria-expanded', 'true');
      setTimeout(() => notes.querySelector('textarea')?.focus(), 60);
    });
    notes.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes.classList.remove('active');
        notes.inert = true;
        notes_toggle.setAttribute('aria-expanded', 'false');
        this.saveNotes();
        notes_toggle.focus();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        // Focus is restorable only if it is in the drawer (or already lost to <body>) right
        // before the re-render; if the user moved it elsewhere meanwhile, leave it there.
        const focusBefore = document.activeElement;
        const upsellKey = focusBefore && focusBefore.dataset ? focusBefore.dataset.fwUpsell : null;
        const restoreFocus = this.container.classList.contains('active') &&
          (!focusBefore || focusBefore === document.body || this.container.contains(focusBefore));

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();

        // Replacing the drawer contents removes the focused node (e.g. the close button that
        // cart-drawer:open focused after an add), which drops focus to <body>. Put it back.
        if (restoreFocus && (!document.activeElement || document.activeElement === document.body)) {
          const again = upsellKey ? Array.prototype.find.call(this.container.querySelectorAll('[data-fw-upsell]'), (b) => b.dataset.fwUpsell === upsellKey) : null;
          (again || this.container.querySelector('.side-panel-close button') || this.container).focus({ preventScroll: true });
        }
      });
  }
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.hidePanel();
        this.detailsements.button.focus();
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.removeAttribute('inert');
        (this.drawer.querySelector('.side-panel-close button') || this.drawer).focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}
document.addEventListener('DOMContentLoaded', () => {

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

// Add-ons

// Shared add-on rule. Must match snippets/cart-drawer.liquid (is_addon_product):
// the Baker's Pick variant, OR product title/type containing "add-on" / "addon".
function isAddonItem(item) {
  if (Number(item.variant_id) === 46319010283651) return true;
  const title = String(item.product_title || '').toLowerCase();
  const type = String(item.product_type || '').toLowerCase();
  return title.includes('add-on') || title.includes('addon') || type.includes('add-on') || type.includes('addon');
}

(function () {
  // The guard's own requests go through the underlying fetch, captured before the
  // wrapper below is installed, so they never schedule another background check.
  // Background checks are scheduled only by independent cart mutations (other code),
  // so a failed correction is not retried until a new mutation, Checkout, or page load.
  const baseFetch = window.fetch.bind(window);
  let checkoutNavigating = false;
  window.addEventListener('pagehide', () => { checkoutNavigating = true; });
  window.addEventListener('pageshow', () => { checkoutNavigating = false; });
  function quietCheckoutFailure(error) {
    return error && (error.name === 'AbortError' ||
      (checkoutNavigating && error.name === 'TypeError' && /failed to fetch|fetch failed|networkerror|load failed/i.test(error.message)));
  }
  // A cart JSON is only trusted when it has no error fields and an items array.
  // HTTP 200 alone is not proof (Shopify can return 200 with errors or an unchanged cart).
  function validateCart(cart) {
    if (!cart || typeof cart !== 'object' || cart.errors ||
        (typeof cart.status === 'number' && cart.status >= 400) || !Array.isArray(cart.items)) {
      throw new Error('Cart response invalid');
    }
    return cart;
  }

  function assertAddonsCapped(cart) {
    if (cart.items.some(item => isAddonItem(item) && Number(item.quantity) !== 1)) {
      throw new Error('Add-on quantity not capped');
    }
    return cart;
  }

  async function readCart() {
    const response = await baseFetch('/cart.js');
    if (!response.ok) {
      throw new Error('Cart read failed');
    }
    return validateCart(await response.json());
  }

  // Resolves when every add-on line is confirmed at quantity 1 (correcting it if needed).
  // Rejects if the cart cannot be read, the correction fails, or the returned cart is not capped.
  // knownCart: an already validated /cart.js read, so a background check reads the cart once.
  async function forceAddonQtyToOne(knownCart) {
    const cart = knownCart || await readCart();

    const updates = {};

    cart.items.forEach(item => {
      if (isAddonItem(item) && item.quantity !== 1) {
        updates[item.key] = 1;
      }
    });

    if (Object.keys(updates).length) {
      const updateResponse = await baseFetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!updateResponse.ok) {
        throw new Error('Add-on quantity correction failed');
      }

      // Confirm the correction from the returned cart, not from the HTTP status.
      assertAddonsCapped(validateCart(await updateResponse.json()));

      // A confirmed correction happened: re-render the drawer, bubble and /cart in place.
      // Loop-safe: this correction used baseFetch, so it schedules no follow-up check,
      // and cart:refresh only re-renders sections (no cart mutation).
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  // Orphan add-on cleanup: the ONE implementation, shared by the drawer on every page and /cart.
  // An orphan cart has add-on lines but no main product (shared isAddonItem rule).
  function isOrphanCart(cart) {
    return cart.items.some(isAddonItem) && !cart.items.some(item => !isAddonItem(item));
  }

  // Removes the add-on line(s) from a confirmed orphan cart: one /cart/change.js per add-on
  // line (the add-on is capped at 1 line in practice, so normally exactly one call), each
  // confirmed from the returned cart, then ONE cart:refresh. Checkout stays blocked
  // (fwOrphanCleanupBlocked, read by main-cart's checkout guard) until removal is confirmed.
  async function removeOrphanAddons(cart) {
    window.fwOrphanCleanupBlocked = true;
    document.dispatchEvent(new CustomEvent('fw:orphan-checkout-block'));
    try {
      let current = cart;
      const keys = cart.items.filter(isAddonItem).map(item => item.key);
      for (const key of keys) {
        const response = await baseFetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (!response.ok) {
          throw new Error('Orphan add-on removal failed');
        }
        current = validateCart(await response.json());
      }
      if (current.items.some(isAddonItem)) {
        throw new Error('Orphan add-on removal was not confirmed');
      }
      window.fwOrphanCleanupBlocked = false;
      // Loop-safe: the removal used baseFetch (schedules no check), and cart:refresh only
      // re-renders sections; it never dispatches line-item:change:end or mutates the cart.
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      window.fwOrphanCleanupBlocked = true;
      document.dispatchEvent(new CustomEvent('fw:orphan-checkout-block'));
      console.error('Orphan add-on cleanup failed', error);
      throw error;
    }
  }

  // One confirmed /cart.js read decides: orphan cart -> remove the add-on; otherwise cap
  // add-ons at quantity 1 (unchanged rule). The free cookie guard is separate and untouched.
  async function reconcileAddons() {
    const cart = await readCart();
    if (isOrphanCart(cart)) {
      await removeOrphanAddons(cart);
      return;
    }
    await forceAddonQtyToOne(cart);
  }

  // Background checks only: errors are swallowed and NOT retried automatically.
  // The next independent cart mutation, a Checkout tap, or a page load tries again.
  // Re-entrancy guard: a trigger that arrives mid-run queues exactly one follow-up run.
  // Only real cart mutations trigger a run, and the run's own writes and refresh never
  // do, so the follow-up cannot chain into a loop.
  let pendingCheck = null;
  let reconcileRunning = false;
  let reconcileQueued = false;
  function reconcileAddonsSafely() {
    if (pendingCheck) {
      clearTimeout(pendingCheck);
      pendingCheck = null;
    }
    if (reconcileRunning) {
      reconcileQueued = true;
      return Promise.resolve();
    }
    reconcileRunning = true;
    return reconcileAddons().catch(function () {}).finally(function () {
      reconcileRunning = false;
      if (reconcileQueued) {
        reconcileQueued = false;
        reconcileAddonsSafely();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', reconcileAddonsSafely);
  // The theme's CartDrawer and Cart dispatch this after a quantity change or removal has
  // completed and been rendered (drawer on any page, and /cart).
  document.addEventListener('line-item:change:end', reconcileAddonsSafely);

  function showCheckoutRetry(checkoutBtn) {
    const holder = checkoutBtn.parentNode;
    if (!holder) return;
    let msg = holder.querySelector('.fw-checkout-retry');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'fw-checkout-retry';
      msg.setAttribute('role', 'alert');
      msg.style.margin = '8px 0 0';
      msg.style.fontSize = '14px';
      msg.style.color = '#b00020';
      checkoutBtn.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = "We couldn't update your cart. Please try again.";
  }

  function clearCheckoutRetry(checkoutBtn) {
    const msg = checkoutBtn.parentNode && checkoutBtn.parentNode.querySelector('.fw-checkout-retry');
    if (msg) msg.remove();
  }

  // Checkout: fail CLOSED. Only navigate once the add-on cap is confirmed.
  document.addEventListener('click', async function (e) {
    const checkoutBtn = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], .checkout-button, .button.checkout'
    );

    if (!checkoutBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (checkoutBtn.disabled || checkoutBtn.getAttribute('aria-disabled') === 'true') return;
    const checkoutRoot = checkoutBtn.closest('#Cart-Drawer, #Cart');
    const terms = checkoutRoot && checkoutRoot.querySelector('#CartDrawerTerms, #CartTerms');
    if (terms && !terms.checked) {
      terms.reportValidity();
      terms.focus();
      return;
    }

    // Recheck the shared add-on rule before navigating, including stale drawer clicks.
    try {
      const checkoutCart = await readCart();
      if (!checkoutCart.items.some(item => !isAddonItem(item))) {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('aria-disabled', 'true');
        const label = checkoutBtn.querySelector('span');
        if (label) label.textContent = 'Add another product to checkout';
        if (checkoutRoot) {
          checkoutRoot.querySelectorAll('.additional-checkout-buttons').forEach(el => { el.hidden = true; });
        }
        return;
      }
    } catch (error) {
      if (!quietCheckoutFailure(error)) showCheckoutRetry(checkoutBtn);
      return;
    }

    let capped = false;
    try {
      await forceAddonQtyToOne();
      // Final gate: a fresh cart read right before navigating must still have a
      // non-add-on item and every add-on line at exactly 1.
      const finalCart = assertAddonsCapped(await readCart());
      if (!finalCart.items.some(item => !isAddonItem(item))) {
        throw new Error('Add-on only cart');
      }
      capped = true;
    } catch (err) {
      if (quietCheckoutFailure(err)) return;
      capped = false;
    }

    if (!capped) {
      showCheckoutRetry(checkoutBtn);
      return;
    }

    if (checkoutNavigating) return;
    clearCheckoutRetry(checkoutBtn);
    window.location.href = '/checkout';
  }, true);

  // Independent cart mutations (other scripts) schedule ONE background check,
  // debounced, so a burst of mutations does not queue several checks. A theme
  // line-item:change:end that follows runs the check at once and clears this timer.
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      if (pendingCheck) clearTimeout(pendingCheck);
      pendingCheck = setTimeout(function () {
        pendingCheck = null;
        reconcileAddonsSafely();
      }, 500);
    }

    return response;
  };
})();